'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    let c = this.$stateParams.category;
    this.getCategories(c)
  }

  getCategories(c) {
    let params = {};
    if (c) {
      params.category = c;
    }
    this.$http.get('/api/categories', { params: params }).then(response => {
      this.categories = response.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete('/api/categories/' + id).then(response => {
        this.getApps(this.category);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/categories/list/list.controller.js